import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import './styles/CreateStudentPage.css'; // Import the scoped CSS
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import moment from 'moment';
import { MdDelete } from "react-icons/md";
import { BsFiles } from "react-icons/bs";
import InventoryListPopupStudent from './InventoryListPopupStudent';
import { generatePaymentReceiptPDF } from './util/paymentReceipt';

function StudentFormPage({ isSidebarCollapsed }) {
  //const [formData, setFormData] = useState({
  //  join_date: moment().format('YYYY-MM-DD'), // Default to today’s date
  //});
  const [branchList, setBranchList] = useState([]);
  const [programList, setProgramList] = useState([]);
  const [levelList, setLevelList] = useState([]);
  const [packageData, setPackageData] = useState({ costs: [] });
  const [isLevelSelected, setIsLevelSelected] = useState(false); // Menandakan apakah level sudah dipilih
  const [errors, setErrors] = useState({}); // Untuk menyimpan pesan error
  const [contactPersons, setContactPersons] = useState([]);
  const [sppDiscounted, setSppDiscounted] = useState(false); // state to track if SPP should be discounted
  const navigate = useNavigate(); 
  const [items, setItems] = useState([]);
  const [showInventoryPopup, setShowInventoryPopup] = useState(false);
  const [isEnglishClubChecked, setIsEnglishClubChecked] = useState(false);
  const [name, setName] = useState('');
  const [relationship, setRelationship] = useState('');
  const [phone, setPhone] = useState('');

  useEffect(() => {
    // Fetch data for branches and programs when page loads
    api.get('/utils/getBranchList')
      .then(response => setBranchList(response.data.data.branchList))
      .catch(error => console.error('Error fetching branch list:', error));

    api.get('/utils/getProgramList')
      .then(response => setProgramList(response.data.data.programList))
      .catch(error => console.error('Error fetching program list:', error));
  }, []);

  const handleProgramChange = (programId) => {
    api.get(`/utils/getLevelList?program_id=${programId}`)
      .then(response => setLevelList(response.data.data.levelList))
      .catch(error => console.error('Error fetching level list:', error));
  };

  const handleLevelChange = (levelId) => {
    if (levelId) {
      api.get(`/utils/getPackage?level_id=${levelId}`)
        .then(response => {
          setPackageData(response.data.data);
          setIsLevelSelected(true); // Set menjadi true saat level dipilih
        })
        .catch(error => console.error('Error fetching package data:', error));
    } else {
      setIsLevelSelected(false); // Reset jika level kosong atau di-reset
    }
  };

  // Fungsi untuk memformat angka tanpa desimal
  const formatNumber = (number) => {
    return Number(number).toLocaleString('id-ID', { maximumFractionDigits: 0 });
  };

  // Fungsi untuk menghitung total harga
  const calculateTotalHarga = () => {
    const totalCost = packageData.costs.reduce((total, cost) => {
      if (cost.cost_item.includes("SPP") && sppDiscounted) {
        return total + (Number(cost.cost_amount) * 0.5); // 50% discount
      }
      return cost.cost_amount > 0 ? total + Number(cost.cost_amount) : total;
    }, 0);
    
    const totalInventory = items.reduce((total, item) => {
      return item.price !== 0 ? total + Number(item.price) : total;
    }, 0);

    return totalCost + totalInventory;
  };

  const handleJoinDateChange = (e) => {
    const joinDate = e.target.value;
    const dayOfMonth = moment(joinDate).date();
    setSppDiscounted(dayOfMonth > 15);
  };

  // Fungsi untuk validasi form
  const validateForm = (formData) => {
    const errors = {};

    // Cek jika field kosong
    if (!formData.student_name) errors.student_name = 'Student name is required';
    if (!formData.birth_date) errors.birth_date = 'Birth date is required';
    if (formData.religion === "") errors.religion = 'Religion is required';
    if (formData.branch_id === "") errors.branch_id = 'Branch is required';
    if (!formData.address) errors.address = 'Address is required';
    if (!formData.join_date) errors.join_date = 'Join date is required';
    if (!formData.contact_persons || formData.contact_persons.length === 0) {
      errors.contact_persons = 'At least one contact person is required';
    }
    //if (!formData.paymentMethod) errors.paymentMethod = 'Payment Method is required';
    if (!formData.program_id) errors.program_id = 'Program is required';
    if (!formData.level_id) errors.level_id = 'Level is required';
    
    if (!formData.payment_date) errors.payment_date = 'Payment date is required';

    return errors;
  };

  const handleSelectItems = (selectedItems) => {
    // Ambil item yang belum ada di daftar
    const newItems = selectedItems.filter(selectedItem => 
        !items.some(item => item.inventory_id === selectedItem.inventory_id)
    );

    if (newItems.length > 0) {
        setItems((prevItems) => [...prevItems, ...newItems]);
    } 
};

  const handleCheckboxChange = async (e) => {
    setIsEnglishClubChecked(e.target.checked);

    if (e.target.checked) {
        // Panggil API untuk mendapatkan data
        try {
            const response = await api.get('/utils/geteccost'); // Ganti dengan endpoint yang sesuai
            const costData = response.data; // Sesuaikan dengan struktur data yang diterima

            // Tambahkan ke packageData.costs jika belum ada
            setPackageData((prevData) => {
                const exists = prevData.costs.some(cost => cost.cost_item === 'SPP ENGLISH CLUB');
                if (!exists) {
                    return {
                        ...prevData,
                        costs: [...prevData.costs, costData],
                    };
                }
                return prevData; // Jika sudah ada, tidak perlu menambah
            });
        } catch (error) {
            console.error('Error fetching English Club cost:', error);
        }
    } else {
        // Hapus item dari packageData.costs
        setPackageData((prevData) => ({
            ...prevData,
            costs: prevData.costs.filter(cost => cost.cost_item !== 'SPP ENGLISH CLUB'), // Sesuaikan dengan nama item
        }));
    }
};


  // Fungsi untuk handle submit form
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = {
      student_name: e.target.student_name.value,
      birth_date: e.target.birth_date.value,
      religion: e.target.religion.value,
      branch_id: e.target.branch_id.value,
      address: e.target.address.value,
      join_date: e.target.join_date.value,
      program_id: e.target.program_id.value,
      level_id: e.target.level_id.value,
      contact_persons: contactPersons, 
      payment_date: e.target.payment_date.value,
      paymentMethod: e.target.paymentMethod.value,// Menyimpan semua kontak person
    };

    const validationErrors = validateForm(formData);

    if (Object.keys(validationErrors).length > 0) {
      // Jika ada error, set state errors untuk menampilkan pesan error
      setErrors(validationErrors);
      console.log('Validation Errors:', validationErrors);
    } else {
      const confirmation = window.confirm('Are you sure you want to proceed with this action?');
      if (!confirmation) {
        return;
      }
      const paymentDate = moment(formData.join_date);
      const paymentMonth = paymentDate.month() + 1; 
      const paymentYear = paymentDate.year();
      const halfMonth = sppDiscounted ? true : false;

      // Kirim data form jika validasi berhasil
      const requestBody = {
        data: {
          studentData: {
            student_name: formData.student_name,
            religion: formData.religion,
            birth_date: formData.birth_date,
            branch_id: formData.branch_id,
            address: formData.address,
            join_date: formData.join_date
          },
          inventoryData: items.map(item => ({
              inventory_id: item.inventory_id,
              price: item.price,
              item_type: item.item_type
            }))
          ,
          contactPersonData: contactPersons.map(contact => ({
            contact_person_name: contact.name,
            relationship: contact.relationship,
            phone_number: contact.phone
          })),
          costData: packageData.costs.map(cost =>({
              cost_id: cost.cost_id,
              cost_amount: cost.cost_amount
          })),
          programData: {
            level_id: formData.level_id
          },
          paymentData: {
            payment_date: formData.payment_date,  // Set as today’s date
            payment_amount: calculateTotalHarga(),  // Total payment calculated
            payment_month: paymentMonth, // Current month
            payment_year: paymentYear, 
            half_month: halfMonth, 
            english_club: isEnglishClubChecked,
            payment_method: formData.paymentMethod
          }
        }
      };
      
      api.post('/student/add-student', requestBody)
        .then(response => {
          const studentCode = response.data.data;
          handleGeneratePDF(studentCode);
          navigate('/success', { state: { message: 'Data siswa berhasil diinput!' } });
        })
        .catch(error => {
          console.error('Error adding student:', error);
          navigate('/error', { state: { message: 'Please ask to administrator!' } });
        });
    }
  };

  // Fungsi untuk menambah kontak person
  const addContactPerson = () => {
    setContactPersons([...contactPersons, { name, relationship, phone }]);
    setName('');
    setRelationship('');
    setPhone('');
  };

  const handleDeletecontactPerson = (index) => {
    const updatedContactPersons = contactPersons.filter((_, i) => i !== index);
    setContactPersons(updatedContactPersons);
  };

  const handleDeleteItem = (index) => {
    const newItems = items.filter((_, i) => i !== index);
    setItems(newItems);
};

const handleGeneratePDF = (studentId) => {
  const studentName = document.querySelector('input[name="student_name"]')?.value || 'New Student';
  const studentData = {
    student_name: studentName,
    student_code: studentId ? studentId : '-',
  };

  const paymentDate = document.querySelector('input[name="payment_date"]')?.value;
  const paymentMethod = document.querySelector('select[name="paymentMethod"]')?.value;

  const paymentData = {
    paymentDate,
    paymentMethod,
  };

  // Combine biaya dari package dan inventory
  const paymentDetails = [
    ...packageData.costs.map(item => ({
      item: item.cost_item,
      amount: sppDiscounted && item.cost_item.includes("SPP")
        ? Number(item.cost_amount) * 0.5
        : Number(item.cost_amount)
    })),
    ...items.map(item => ({
      item: item.item_name,
      amount: Number(item.price)
    }))
  ];

  generatePaymentReceiptPDF(studentData, paymentData, paymentDetails, paymentDate, 'NEW');
};


  return (
    <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
      <div className="page-title">Register New Student</div>
      <div className="form-container">
        <form onSubmit={handleSubmit}>
          {/* Student Data Section */}
          <div className="section">
            <h3 className="section-header">Student Data</h3>
            <label>Student Name</label>
            <input type="text" name="student_name" />
            {errors.student_name && <div className="error-message">{errors.student_name}</div>}

            <label>Birth Date</label>
            <input type="date" name="birth_date" />
            {errors.birth_date && <div className="error-message">{errors.birth_date}</div>}

            <label>Religion</label>
            <select name="religion">
              <option key="" value="">Select Religion</option>
              <option key="Christian" value="Christian">Christian</option>
              <option key="Islam" value="Islam">Islam</option>
              <option key="Catholic" value="Catholic">Catholic</option>
              <option key="Confucius" value="Confucius">Confucius</option>
              <option key="Buddha" value="Buddha">Buddha</option>
              <option key="Hindu" value="Hindu">Hindu</option>
            </select>
            {errors.religion && <div className="error-message">{errors.religion}</div>}

            <label>Branch</label>
            <select name="branch_id">
              <option key="" value="">Select Branch</option>
              {branchList.map(branch => (
                <option key={branch.branch_id} value={branch.branch_id}>{branch.branch_name}</option>
              ))}
            </select>
            {errors.branch_id && <div className="error-message">{errors.branch_id}</div>}

            <label>Address</label>
            <textarea name="address"></textarea>
            {errors.address && <div className="error-message">{errors.address}</div>}

            <label>Join Date</label>
            <input type="date" name="join_date" onChange={handleJoinDateChange}/>
            {errors.join_date && <div className="error-message">{errors.join_date}</div>}
          </div>

          {/* Contact Person Data Section */}
          <div className="section">
            <h3 className="section-header">Contact Person Data</h3>
            <div className="contact-person">
              <label>Contact Person Name</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <label>Relationship</label>
              <input
                type="text"
                value={relationship}
                onChange={(e) => setRelationship(e.target.value)}
              />
              <label>Phone Number</label>
              <input
                type="text"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
            <div className="search-container">
              <button type="button" onClick={addContactPerson}>Add Contact Person</button>
            </div>
            <div className="inventory-list">
              <table>
                  <thead>
                      <tr>
                          <th class="no-column">No</th>
                          <th>Contact Person Name</th>
                          <th>Relationship</th>
                          <th>Phone Number</th>
                          <th>Actions</th>
                      </tr>
                  </thead>
                  <tbody>
                      {contactPersons.map((contact, index) => (
                          <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{contact.name}</td>
                          <td>{contact.relationship}</td>
                          <td>{contact.phone}</td>
                          <td>
                              <MdDelete className="icon" onClick={() => handleDeletecontactPerson(index)} />  
                          </td>
                          </tr>
                      ))}
                  </tbody>
              </table>
            </div>
          </div>

          {/* Program Data Section */}
          <div className="section">
            <h3 className="section-header">Program Data</h3>
            <label>Program</label>
            <select name="program_id" onChange={e => handleProgramChange(e.target.value)}>
              <option>Select Program</option>
              {programList.map(program => (
                <option key={program.program_id} value={program.program_id}>{program.program_name}</option>
              ))}
            </select>
            {errors.program_id && <div className="error-message">{errors.program_id}</div>}

            <label>Level</label>
            <select name="level_id" onChange={e => handleLevelChange(e.target.value)}>
              <option>Select Level</option>
              {levelList.map(level => (
                <option key={level.level_id} value={level.level_id}>{level.level_name}</option>
              ))}
            </select>
            {errors.level_id && <div className="error-message">{errors.level_id}</div>}
          </div>

          {isLevelSelected && (
            <div className="create-student-table">
              <h3 className="section-header">Package Details</h3>
            </div>
          )}
          {isLevelSelected && (
            <div className="package-details">
              <table>
                <tbody>
                  <tr>
                    <td>
                      <label>Add Item</label>
                    </td>
                    <td>
                      <BsFiles className="icon" onClick={() => setShowInventoryPopup(true)} />
                    </td>
                  </tr>
                  <tr>
                  <td>
                    <label>English Club</label>
                  </td>
                  <td>
                    <input
                        type="checkbox"
                        checked={isEnglishClubChecked}
                        onChange={handleCheckboxChange}
                    />
                  </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
          {isLevelSelected && (
            
            <div className="create-student-table">
              <table>
                <thead>
                  <tr>
                    <th className='table-center-align'>Item Name</th>
                    <th className='table-center-align'>Price</th>
                    <th className='no-column'>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Tampilkan data dari costs */}
                  {packageData.costs.map((cost, index) => (
                    <tr key={`cost-${index}`}>
                      <td>{cost.cost_item}</td>
                      <td className='table-right-align'>{cost.cost_item.includes("SPP") && sppDiscounted ? formatNumber(cost.cost_amount * 0.5) : formatNumber(cost.cost_amount)}</td>
                      <td></td>
                    </tr>
                  ))}
                  {items.map((item, index) => (
                    <tr key={index}>
                      <td>{item.item_name}</td>
                      <td>{formatNumber(item.price)}</td>
                      <td>
                          <MdDelete className="icon" onClick={() => handleDeleteItem(index)} />  
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td><strong>Total Pembayaran</strong></td>
                    <td className='table-right-align'><strong>{formatNumber(calculateTotalHarga())}</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
          <div className="section">
            <h3 className="section-header">Payment Data</h3>
            <label>Payment Date</label>
            <input type="date" name="payment_date"/>
            {errors.payment_date && <div className="error-message">{errors.payment_date}</div>}
            <label>Payment Method</label>
            <select name="paymentMethod">
                <option key="" value="">Choose Payment Method</option>
                <option key="BANK BCA" value="BANK BCA">BANK BCA</option>
                <option key="BANK BRI" value="BANK BRI">BANK BRI</option>
            </select>
          </div>
          
          <div className="search-container">
            <button type="submit">Submit</button>  
          </div>
          {showInventoryPopup && (
            <InventoryListPopupStudent onSelectItems={handleSelectItems} onClose={() => setShowInventoryPopup(false)} />
          )}
        </form>
      </div>
    </div>
  );
}

export default StudentFormPage;
